import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAdminSession, useBrowserSession } from '../_lib/browserSession';

const PublicRoute = ({ component: Component, ...rest }) => {
    const session = useBrowserSession();
    // Only an admin session is sent away from the login screen. A signed-in
    // non-admin must be able to reach it and sign in properly.
    const allowed = isAdminSession(session);
    return (
        <Route {...rest} render={props => (
            allowed ? <Redirect to={{ pathname: '/profile', state: { from: props.location } }} /> : <Component {...props} />
        )} />
    );

};

export default PublicRoute;
